import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        const target = data.user?.role === "admin" ? "/admin" : "/dashboard";
        // Clear the hash and navigate
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFFFF]" data-testid="auth-callback">
      <div className="text-center">
        <div className="inline-block h-8 w-8 border-2 border-[#1B2E7A] border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-[#374151]">Validando tu sesión...</p>
      </div>
    </div>
  );
}
